import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '@repo/ui-components/styles';

const Container = styled.div`
  min-height: 30px;
  display: flex;
  background: ${({ theme }) => theme.notificationBanner.background};
  transition: box-shadow 0.3s ease-in-out;
  position: ${({ sticky }) => (sticky ? 'sticky' : 'relative')};
  box-shadow: ${({ showShadow }) =>
    showShadow ? '0 2px 4px 0 rgba(0, 0, 0, 0.35)' : 'none'};
  z-index: 3;
  top: 0;
  color: white;
  font-weight: normal;
  font-size: ${styles.fontSize.sm};

  a {
    color: white;
    font-weight: normal;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

function DemoChatComponent() {
  return (
    <div>
      <div>Live Chat</div>
    </div>
  );
}

function debounce(method, delay) {
  const methodToDebounce = method;

  clearTimeout(methodToDebounce.timeoutId);

  methodToDebounce.timeoutId = setTimeout(() => {
    method();
  }, delay);
}

function NotificationBanner({ sticky }) {
  const [showShadow, setShowShadow] = useState(false);
  const isBrowser = typeof window !== 'undefined';

  // debounce scroll event
  if (isBrowser) {
    window.onscroll = () => {
      debounce(() => {
        if (window.scrollY > 0 && sticky) {
          setShowShadow(true);
        }
        if (window.scrollY === 0 && sticky) {
          setShowShadow(false);
        }
      }, 100);
    };
  }

  return <Container sticky={sticky} showShadow={showShadow} />;
}

NotificationBanner.propTypes = {
  sticky: PropTypes.bool,
  ChatComponent: PropTypes.shape({}),
};

NotificationBanner.defaultProps = {
  sticky: false,
  ChatComponent: DemoChatComponent,
};

export default NotificationBanner;
